/* Scroll reveal v3 — section reveals + staggered product-card entrances.
   CSS lives in custom.css (section 6b). Hidden states only apply while
   <html> has the .sr-armed class, which THIS script adds right before
   attaching observers. If the script never runs (theme editor re-renders,
   blocked JS, 404), nothing is ever hidden — content stays visible.
   In the Shopify theme editor we skip entirely: every section re-render
   would otherwise leave fresh DOM stuck at opacity 0. */
(() => {
  if (window.Shopify && window.Shopify.designMode) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  document.documentElement.classList.add('sr-armed');

  /* 1. Whole-section reveals (custom sections opt in with .scroll-reveal) */
  const revealObserver = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15 }
  );

  document.querySelectorAll('.scroll-reveal').forEach((el) => revealObserver.observe(el));

  /* 2. Staggered product grids — group Horizon's grid items by parent,
     assign an incremental delay per item (capped so long grids never
     feel slow: items past the 7th enter together). */
  const STAGGER_MS = 55;
  const STAGGER_CAP = 7;

  const groupObserver = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
  );

  const groups = new Map();
  document
    .querySelectorAll('.resource-list__item, .product-grid__item')
    .forEach((item) => {
      const parent = item.parentElement;
      if (!parent) return;
      if (!groups.has(parent)) groups.set(parent, []);
      groups.get(parent).push(item);
    });

  groups.forEach((items, parent) => {
    items.forEach((item, index) => {
      item.style.setProperty('--reveal-delay', `${Math.min(index, STAGGER_CAP) * STAGGER_MS}ms`);
    });
    parent.classList.add('reveal-group');
    groupObserver.observe(parent);
  });

  /* Safety net: whatever is still hidden 4s after load becomes visible.
     Covers observers that never fire (e.g. layout shifts, browser quirks). */
  window.addEventListener('load', () => {
    setTimeout(() => {
      document
        .querySelectorAll('.scroll-reveal:not(.is-visible), .reveal-group:not(.is-visible)')
        .forEach((el) => el.classList.add('is-visible'));
    }, 4000);
  });
})();
